import { Cache } from "memory-cache";
import { CharacterOrderHistoryEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterOrderHistoryEntity(
  order_id: number
): Promise<CharacterOrderHistoryEntity | null> {
  let entity: any = await cache.get(order_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterOrderHistoryEntity(order: CharacterOrderHistoryEntity) {
  cache.put(order.props.order_id.toString(), order, 60 * 60 * 1000 /* 1 hour */);
}
